module.exports = __webpack_public_path__ + "img/keitaro-landing-step-5.ru.e0bf1030.jpg";